import { FunctionComponent, useMemo } from 'react';
import { useEducatorForm } from '../../data/useEducatorForm';
import { CademyError } from '@shared/domain-shared';
import { Form } from '../Form';
import { Field } from '@shared/types';

type EducatorFormProps = {
    formId: string;
    error?: CademyError | null;
    disabled?: boolean;
    disabledFields?: Array<Field['_id']>;
};
export const EducatorForm: FunctionComponent<EducatorFormProps> = ({ formId, ...props }) => {
    const { data: form, isLoading } = useEducatorForm(formId);

    const fields = useMemo((): Array<Field> => {
        if (!form) {
            return [];
        }
        return form.fields.filter((field) => {
            // Marketing consent is gathered separately from the Form
            return field._id !== 'educator_marketing_consent';
        });
    }, [form]);

    if (!form || isLoading) {
        return <p>...Loading</p>;
    }

    return <Form {...props} fields={fields} validations={form.validations} />;
};
